module.exports = __webpack_public_path__ + "img/发票信息.c921a47b.svg";